import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from '../services/authentication.service';

@Component({
    selector: 'app-bulk-email',
    templateUrl: './bulk-email.html'
  })
  export class BulkEmailComponent implements OnInit {

    form1: FormGroup;
    submitting = false;

    constructor( private fb: FormBuilder , private authService : AuthenticationService){
      this.ngOnInit();
    }

    ngOnInit(): void {
      this.form1 = this.fb.group({
        subject: new FormControl('', [Validators.required]),
        message: new FormControl('', [Validators.required])
      })
    }

    onSubmit(){
      this.submitting = true;
      this.authService.bulkEmail(this.form1.value);
    }
  }